import React, { forwardRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AiFillCheckCircle, AiFillCloseCircle } from "react-icons/ai";
import { FaRegClock } from "react-icons/fa6";
import styles from "./Pricing.module.css";
import { createAnnualPlans } from './PlanUtils';
import { useSelector } from 'react-redux';

const PlanCard = forwardRef(({ plan, activeTab, index, activePlan, handlePlanAction, isLoading }, ref) => {
    // activeTab === "monthly" ? monthlyPlans : annualPlans;

    const { t } = useTranslation();
    
    const user = useSelector(state => state.user.user);
    const [cycle, setCycle] = useState('monthly');
    
    const planClone = cycle === 'monthly' ? plan : createAnnualPlans(user)[2];

    const isActive = planClone.priceId == user?.activeSubscriptionPriceId && activePlan === index && activePlan !== 0;
    
    // Get the feature titles from the first plan (which contains only titles)
    const featureTitles = [
        t('employer_plan.features.Instant_Job_Activation'),
        t('employer_plan.features.Applications_Per_Job'),
        t('employer_plan.features.Monthly_Jobs'),
        t('employer_plan.features.Jobseekers_DB_Access'),
        t('employer_plan.features.View_Applicant_Profile'),
        t('employer_plan.features.Contact_Applicant'),
        t('employer_plan.features.View_Download_Resume')
    ];

    // Function to render the feature text based on value and index
    const renderFeatureText = (value, index) => {
        // Handle specific cases based on the index
        switch (index) {
            case 0: // Instant Job Activation
                return featureTitles[index];
            case 1: // Applications Per Job
                if (typeof value === 'string' && value) {
                    return `${value} ${featureTitles[index]}`;
                }
                return featureTitles[index];
            case 2: // Monthly Jobs
                if (value === t('general.UI.unlimited')) {
                    return `${value} ${featureTitles[index]}`;
                } else if (typeof value === 'string' && value) {
                    return `${value} ${featureTitles[index]}`;
                }
                return featureTitles[index];
            default:
                return featureTitles[index];
        }
    };

    return (
        <div
            className={`${styles.planCard} ${isActive ? styles.activePlan : ''}`}
            ref={ref}
        >
            <p className={styles.planName}>{planClone.name} <span className={styles.plan}>{t('employer_plan.plan')}</span></p>
            {isActive && <div className={styles.activeBadge}>{t('subscription.current_plan', "Current Plan")}</div>}
            {
                activeTab == 'monthly' &&
                (planClone.priceId == "price_1QCbjNRrx5vqVCQqyjvQOWuN" || planClone.priceId == "price_1QhVOpRrx5vqVCQqNAX3kvhn")
                && (
                    <div className={styles.cycleWrapper}>
                        <div className={cycle === 'monthly' ? styles.cycleActive : styles.cycle} onClick={() => setCycle('monthly')}>{t('general.UI.monthly', 'Monthly')}</div>
                        <div className={cycle === 'annually' ? styles.cycleActive : styles.cycle} onClick={() => setCycle('annually')}>{t('general.UI.annually', 'Annually')}</div>
                    </div>
                )}
            <div className={styles.planPrice}>{planClone.price}</div>

            <ul className={styles.featuresList}>
                {planClone.features.map((feature, idx) => (
                    <li key={idx} className={`${styles.featureItem} ${feature === true || (typeof feature === 'string' && feature.length > 0) ? styles.available : styles.unavailable}`}>
                        {feature === true ? (
                            <AiFillCheckCircle className={styles.checkIcon} />
                        ) : feature === false ? (
                            <AiFillCloseCircle className={styles.timesIcon} />
                        ) : (
                            <AiFillCheckCircle className={styles.checkIcon} />
                        )}
                        {renderFeatureText(feature, idx)}
                    </li>
                ))}
            </ul>

            {isActive ? (
                // <button
                //     className={styles.activeSubscribeButton}
                //     disabled={true}
                // >
                //     {t('subscription.active', "Active")}
                // </button>
                user?.activeSubscriptionPriceId == planClone.priceId ?
                    <button
                        className={styles.activeSubscribeButton}
                        disabled={true}
                    >
                        {t('subscription.active', "Active")}
                    </button> :

                    planClone.buttonText && (
                        <button
                            onClick={() => handlePlanAction(planClone)}
                            className={styles.subscribeButton}
                            disabled={isLoading || planClone.buttonText === 'active'}
                        >
                            {isLoading ? t('general.UI.loading') : planClone.buttonText}
                        </button>
                    )

            ) : (
                // Only render the button if buttonText is not empty
                planClone.buttonText && (
                    <button
                        onClick={() => handlePlanAction(planClone)}
                        className={styles.subscribeButton}
                        disabled={isLoading || planClone.buttonText === 'active'}
                    >
                        {isLoading ? t('general.UI.loading') : planClone.buttonText}
                    </button>
                )
            )}

        </div>
    );
});

// Add display name for better debugging
PlanCard.displayName = 'PlanCard';

export default PlanCard; 